module.exports = __webpack_public_path__ + "media/app/assets/avatar-3561dd399efa8f3c847cf72824eb3ebc.png";